import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter for routing
import App from './App';
import reportWebVitals from './reportWebVitals';
import { NextUIProvider } from "@nextui-org/react";
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <NextUIProvider>
    <BrowserRouter> {/* Ensure App is wrapped with BrowserRouter */}
      <ScrollToTop />
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </BrowserRouter>
  </NextUIProvider>
);

reportWebVitals();
